// ============================================================
// SALT - Axios Client
// ============================================================

import axios, { AxiosError } from 'axios';

// In production, REACT_APP_API_URL must be set to an https:// URL.
// The http:// fallback is only for local development.
const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'development'
    ? 'http://localhost:5000/api'
    : '/api'); // Relative path fallback in production — avoids insecure http://

const axiosClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Response interceptor - handle common errors
// Note: console.warn/console.error calls below are acceptable for production.
// CRA production builds do NOT strip console calls automatically. If desired,
// use a Babel plugin (babel-plugin-transform-remove-console) or Terser config
// to strip them in the production bundle. The messages here do not log any
// sensitive data (tokens, PII), only status codes and generic messages.
axiosClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const status = error.response?.status;

    // Handle 401 Unauthorized - clear auth and redirect only for expired sessions.
    // Skip redirect if user was never logged in (allows guest browsing).
    // Skip hard redirect for /me and /verify — the AuthContext handles
    // those 401s gracefully (clears state, shows auth page via React router).
    if (status === 401) {
      const url = error.config?.url || '';
      const isAuthCheck = url.endsWith('/me') || url.endsWith('/verify');
      const wasLoggedIn = !!(localStorage.getItem('sl_auth') || sessionStorage.getItem('sl_auth'));

      localStorage.removeItem('sl_auth');
      sessionStorage.removeItem('sl_auth');

      if (wasLoggedIn && !isAuthCheck && !window.location.pathname.includes('/auth')) {
        window.location.href = '/auth';
      }
    }

    // Handle 429 Rate Limit
    if (status === 429) {
      console.warn('Rate limited. Please wait before trying again.');
    }

    return Promise.reject(error);
  }
);

export default axiosClient;